export const it = {
  statDpiStock: {
    includedBranches: "Includi dai cantieri",
    name: "Inventario DPI",
  },
};
